import { SvrAPk } from "../utils/axios/index";

//----------------------------------------------------------------------------------------------------------------------
export const getBeneficarioFind = async (query) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/beneficiario/getquerybenefic",{query});
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
export const getBeneficarioxDocFind = async (numeroNit) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/beneficiario/getbeneficxdoc",{numeroNit});
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
export const getBeneficitas = async(HistoriaId) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/beneficiario/getbeneficitas",{HistoriaId});
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
export const getBeneficarioxTipoDoc = async (tipodoc, documento) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/beneficiario/getbeneficxtipodoc",{tipodoc, documento});
  } catch (Error) {
    res = Error;
  }
  return res;
};

//----------------------------------------------------------------------------------------------------------------------
export const setRegistrarBeneficiario = async (tipodoc, documento, apellido1, apellido2, nombre1, nombre2, nombre_completo, 
                                               genero, fecha_nacimiento, tipo_sangre) => {
  let res = {};
  try {
    res = await SvrAPk.post("/api/public/beneficiario/setregistrabenef",{tipodoc, documento, apellido1, apellido2, nombre1, nombre2, nombre_completo, 
                                               genero, fecha_nacimiento, tipo_sangre});
  } catch (Error) {
    res = Error;
  }
  return res;
};



